import { BaseService, Service } from "/@/cool";

@Service("shopPackagePrice")
class ShopPackagePrice extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["list"] = prefix + "list";
		this.permission["page"] = prefix + "page";
		this.permission["info"] = prefix + "info";
		this.permission["add"] = prefix + "add";
		this.permission["update"] = prefix + "update";
		this.permission["delete"] = prefix + "delete";
		this.permission["batchSave"] = prefix + "batchSave";
	}

	// 获取门店产品包价格列表
	list(params: any) {
		return this.request({
			url: "/list",
			method: "GET",
			params
		});
	}

	// 获取门店产品包价格分页
	page(params: any) {
		return this.request({
			url: "/page",
			method: "GET",
			params
		});
	}

	// 获取门店产品包价格详情
	info(params: any) {
		return this.request({
			url: "/info",
			method: "GET",
			params
		});
	}

	// 添加门店产品包价格
	add(data: any) {
		return this.request({
			url: "/add",
			method: "POST",
			data
		});
	}

	// 更新门店产品包价格
	update(data: any) {
		return this.request({
			url: "/update",
			method: "POST",
			data
		});
	}

	// 删除门店产品包价格
	delete(data: any) {
		return this.request({
			url: "/delete",
			method: "POST",
			data
		});
	}

	// 批量保存门店产品包价格
	batchSave(data: any) {
		return this.request({
			url: "/batchSave",
			method: "POST",
			data
		});
	}
}

export default ShopPackagePrice;
